import React, { useEffect, useRef, useState } from "react";
import "./style.css";
import KotHeader from "./components/header/KotHeader";
import { useDispatch, useSelector } from "react-redux";
import { switch_to_billing_screen } from "../Sales/Billing/newBillingSlice";
import KotSideMenu from "./components/sideMenu/KotSideMenu";
import KotBody from "./components/kotBody/KotBody";
import KotPopup from "./components/popUp/KotPopup";
import io from "socket.io-client";
import axios from "axios";
import hybridSocket from "../../../offline/hybridSocket";
import {
  kotSideMenuListApi,
  listKotOrderAPI,
  viewKOTSortProductListAPI,
} from "./kotAPI's";
import { listAllBranches } from "../FloorManagement/apis/commonApi";
import {
  setDarkMode,
  setIsLoading,
  setKotOrderList,
  setSelectedKOTOrder,
  setAlertMessage,
  setNetworkStatus,
  setSortProduct,
  setKotOrderStatus,
} from "./kitchenOrderTicketSlice";
import { LoadingForm } from "../../Single Components/LoadingForm";
import AlertMessage from "../FloorManagement/components/alertMessage/AlertMessage";
import { NETWORK } from "./utils/kotEnum";
import { setHideHeader } from "../KotTokenDisplay/kotTokenDisplaySlice";
import { useLocation } from "react-router-dom";
// import { socket } from "../../../API/UrlAndPaths";

const KitchenOrderTicket = () => {
  // =============================
  const user = JSON.parse(localStorage.getItem("login_meta"));

  const userId = user?.data?._id;
  const location = useLocation();

  // =============================
  const dispatch = useDispatch();
  const {
    selectedKOTOrder,
    kotOrderList,
    isLoading,
    alertMessage,
    kotOrderStatus,
    darkMode,
    sortProduct,
    networkStatus,
  } = useSelector((state) => state.kitchenOrderTicketSlice);

  const { branchPk, data, ...rest } = useSelector(
    (state) => state.loginResponseSlice.value
  );

  const [sendBody, setSendBody] = useState({
    status: null,
    branchId: branchPk,
    deviceIds: [],
  });

  const VOICE_SETTINGS_KEY = "kotVoiceSettings";
  const getDefaultVoiceSettings = () => ({
    enabled: false,
    soundEnabled: false,
    soundType: "notification",
    voiceGender: "default",
    voiceLanguage: "en",
    voiceSource: "browser", // "browser" = Windows/system TTS, "ai" = StreamElements Neural
    preferredBrowserVoiceURI: "",
    preferredBrowserVoiceName: "",
    aiVoiceId: "",
    staffId: null,
    staffName: "",
    deviceIds: [],
    types: {
      externalApi: true,
      delivery: true,
      dinein: true,
      pickup: true,
    },
  });

  const [voiceSettings, setVoiceSettings] = useState(getDefaultVoiceSettings());
  const seenKotIdsRef = useRef(new Set());
  const hydratedSeenRef = useRef(false);
  const announceSeqRef = useRef(0);

  const loadVoiceSettings = () => {
    try {
      const raw = localStorage.getItem(VOICE_SETTINGS_KEY);
      if (!raw) return getDefaultVoiceSettings();
      const parsed = JSON.parse(raw);
      return {
        ...getDefaultVoiceSettings(),
        ...parsed,
        types: { ...getDefaultVoiceSettings().types, ...(parsed?.types || {}) },
      };
    } catch (e) {
      return getDefaultVoiceSettings();
    }
  };

  const filterKotOrdersByDevices = (list, deviceIds) => {
    if (!Array.isArray(list)) return [];
    const ids = Array.isArray(deviceIds) ? deviceIds.map((x) => String(x)) : [];
    if (ids.length === 0) return list;
    return list.filter((o) => ids.includes(String(o?.deviceId)));
  };

  const filteredKotOrderList = filterKotOrdersByDevices(
    Array.isArray(kotOrderList) ? kotOrderList : [],
    voiceSettings?.deviceIds
  );

  const playTone = async ({ frequency, durationMs, volume = 0.2 }) => {
    if (typeof window === "undefined") return;
    const AudioCtx = window.AudioContext || window.webkitAudioContext;
    if (!AudioCtx) return;

    const ctx = new AudioCtx();
    try {
      if (ctx.state === "suspended") {
        await ctx.resume();
      }
      const oscillator = ctx.createOscillator();
      const gain = ctx.createGain();
      oscillator.type = "sine";
      oscillator.frequency.value = frequency;

      // envelope
      const now = ctx.currentTime;
      gain.gain.setValueAtTime(0.0001, now);
      gain.gain.exponentialRampToValueAtTime(volume, now + 0.01);
      gain.gain.exponentialRampToValueAtTime(0.0001, now + durationMs / 1000);

      oscillator.connect(gain);
      gain.connect(ctx.destination);
      oscillator.start();
      oscillator.stop(now + durationMs / 1000);

      await new Promise((resolve) => setTimeout(resolve, durationMs + 30));
    } finally {
      try {
        await ctx.close();
      } catch (e) {
        // ignore
      }
    }
  };

  const playNotificationSound = async (type) => {
    // Different simple patterns
    if (type === "alarm") {
      await playTone({ frequency: 880, durationMs: 250, volume: 0.25 });
      await playTone({ frequency: 880, durationMs: 250, volume: 0.25 });
      await playTone({ frequency: 880, durationMs: 250, volume: 0.25 });
      return;
    }

    if (type === "chime") {
      await playTone({ frequency: 523.25, durationMs: 140, volume: 0.22 });
      await playTone({ frequency: 659.25, durationMs: 160, volume: 0.22 });
      await playTone({ frequency: 783.99, durationMs: 180, volume: 0.22 });
      return;
    }

    if (type === "bass_drop") {
      await playTone({ frequency: 220, durationMs: 160, volume: 0.32 });
      await playTone({ frequency: 140, durationMs: 220, volume: 0.34 });
      await playTone({ frequency: 90, durationMs: 260, volume: 0.36 });
      return;
    }

    if (type === "bass_pulse") {
      await playTone({ frequency: 110, durationMs: 140, volume: 0.36 });
      await playTone({ frequency: 110, durationMs: 140, volume: 0.36 });
      await playTone({ frequency: 110, durationMs: 140, volume: 0.36 });
      return;
    }

    if (type === "deep_chime") {
      await playTone({ frequency: 392, durationMs: 220, volume: 0.28 });
      await playTone({ frequency: 523.25, durationMs: 260, volume: 0.26 });
      return;
    }

    if (type === "sonar") {
      await playTone({ frequency: 440, durationMs: 140, volume: 0.18 });
      await playTone({ frequency: 660, durationMs: 180, volume: 0.18 });
      await playTone({ frequency: 880, durationMs: 220, volume: 0.18 });
      return;
    }

    if (type === "double_knock") {
      await playTone({ frequency: 180, durationMs: 120, volume: 0.33 });
      await new Promise((r) => setTimeout(r, 60));
      await playTone({ frequency: 180, durationMs: 120, volume: 0.33 });
      return;
    }

    if (type === "techno") {
      await playTone({ frequency: 740, durationMs: 90, volume: 0.24 });
      await playTone({ frequency: 988, durationMs: 90, volume: 0.24 });
      await playTone({ frequency: 740, durationMs: 90, volume: 0.24 });
      await playTone({ frequency: 587, durationMs: 120, volume: 0.24 });
      return;
    }

    if (type === "drum_hit") {
      await playTone({ frequency: 130, durationMs: 180, volume: 0.38 });
      await playTone({ frequency: 65, durationMs: 200, volume: 0.36 });
      return;
    }

    if (type === "bell") {
      await playTone({ frequency: 784, durationMs: 220, volume: 0.22 });
      await playTone({ frequency: 1046.5, durationMs: 240, volume: 0.20 });
      return;
    }

    if (type === "siren_soft") {
      await playTone({ frequency: 440, durationMs: 180, volume: 0.20 });
      await playTone({ frequency: 660, durationMs: 180, volume: 0.20 });
      await playTone({ frequency: 440, durationMs: 180, volume: 0.20 });
      await playTone({ frequency: 660, durationMs: 180, volume: 0.20 });
      return;
    }

    if (type === "bass_alarm") {
      await playTone({ frequency: 98, durationMs: 220, volume: 0.40 });
      await playTone({ frequency: 98, durationMs: 220, volume: 0.40 });
      await playTone({ frequency: 196, durationMs: 180, volume: 0.34 });
      return;
    }

    // default: notification
    await playTone({ frequency: 660, durationMs: 160, volume: 0.22 });
    await playTone({ frequency: 880, durationMs: 180, volume: 0.22 });
  };

  const languageToVoicePrefixes = (langKey) => {
    const k = (langKey || "en").toLowerCase();
    if (k === "ar") return ["ar", "ar-sa", "ar-ae", "ar-eg"];
    if (k === "hi") return ["hi", "hi-in"];
    if (k === "ml") return ["ml", "ml-in"];
    if (k === "fr") return ["fr", "fr-fr", "fr-ca"];
    if (k === "zh") return ["zh", "zh-cn", "zh-tw", "cmn"];
    return ["en", "en-us", "en-gb", "en-au", "en-in"];
  };

  const pickSpeechVoice = (synth, gender, languageKey) => {
    try {
      const voices = synth?.getVoices?.() || [];
      if (!voices.length) return null;
      const want = (gender || "default").toLowerCase();
      const langPrefixes = languageToVoicePrefixes(languageKey);

      const voiceMatchesLang = (v) => {
        const lang = (v?.lang || "").toLowerCase();
        return langPrefixes.some((p) => lang.startsWith(p));
      };

      const isFemaleVoice = (v) => {
        const s = `${v?.name || ""} ${v?.voiceURI || ""} ${v?.lang || ""}`.toLowerCase();
        return s.includes("female") || s.includes("woman") || s.includes("zira") || s.includes("susan") || s.includes("samantha");
      };
      const isMaleVoice = (v) => {
        const s = `${v?.name || ""} ${v?.voiceURI || ""} ${v?.lang || ""}`.toLowerCase();
        return s.includes("male") || s.includes("man") || s.includes("david") || s.includes("mark") || s.includes("george");
      };

      const qualityScore = (v) => {
        const s = `${v?.name || ""} ${v?.voiceURI || ""} ${v?.lang || ""}`.toLowerCase();
        let score = 0;
        if (voiceMatchesLang(v)) score += 50;
        // Prefer higher quality voices typically named like these
        if (s.includes("natural")) score += 30;
        if (s.includes("neural")) score += 30;
        if (s.includes("online")) score += 20;
        if (s.includes("google")) score += 20;
        if (s.includes("microsoft")) score += 15;
        // Slight preference for non-local voices if available
        if (v?.localService === false) score += 5;
        // Penalize very old "sapi" voices if present
        if (s.includes("sapi")) score -= 5;
        return score;
      };

      const base = voices.filter(voiceMatchesLang);

      const sortByQuality = (arr) => [...arr].sort((a, b) => qualityScore(b) - qualityScore(a));

      if (want === "default") {
        return sortByQuality(base)[0] || null;
      }

      const filtered = base.filter((v) => (want === "female" ? isFemaleVoice(v) : isMaleVoice(v)));
      return sortByQuality(filtered)[0] || sortByQuality(base)[0] || null;
    } catch (e) {
      return null;
    }
  };

  // AI voice using StreamElements TTS API (free, natural voices, no API key required)
  const speakWithAi = async (text) => {
    try {
      // Map language codes to StreamElements voice names
      // These are high-quality natural-sounding voices
      const voiceMap = {
        en: voiceSettings?.voiceGender === "female" ? "en-US-AriaNeural" : "en-US-GuyNeural",
        ar: voiceSettings?.voiceGender === "female" ? "ar-SA-ZariyahNeural" : "ar-SA-HamedNeural",
        hi: voiceSettings?.voiceGender === "female" ? "hi-IN-SwaraNeural" : "hi-IN-MadhurNeural",
        ml: voiceSettings?.voiceGender === "female" ? "ml-IN-SobhanaNeural" : "ml-IN-MidhunNeural",
        fr: voiceSettings?.voiceGender === "female" ? "fr-FR-DeniseNeural" : "fr-FR-HenriNeural",
        zh: voiceSettings?.voiceGender === "female" ? "zh-CN-XiaoxiaoNeural" : "zh-CN-YunxiNeural",
      };

      const overrideVoiceId = (voiceSettings?.aiVoiceId || "").toString().trim();
      const voice = overrideVoiceId || voiceMap[voiceSettings?.voiceLanguage] || voiceMap.en;
      const encodedText = encodeURIComponent(text);

      // StreamElements TTS API - free and no API key needed
      const audioUrl = `https://api.streamelements.com/kappa/v2/speech?voice=${voice}&text=${encodedText}`;

      const audio = new Audio(audioUrl);
      
      return new Promise((resolve) => {
        audio.onended = () => resolve(true);
        audio.onerror = () => {
          console.log("[KOT AI Voice] StreamElements error, falling back to browser TTS");
          resolve(false);
        };
        audio.play().catch(() => {
          console.log("[KOT AI Voice] Audio play failed, falling back to browser TTS");
          resolve(false);
        });
      });
    } catch (error) {
      console.log("[KOT AI Voice] Error:", error?.message, "- falling back to browser TTS");
      return false;
    }
  };

  // Browser speech synthesis fallback
  const speakWithBrowser = (text) => {
    try {
      if (typeof window === "undefined") return;
      if (!("speechSynthesis" in window)) return;
      const synth = window.speechSynthesis;
      synth.cancel();
      const utter = new SpeechSynthesisUtterance(text);
      const preferredURI = (voiceSettings?.preferredBrowserVoiceURI || "").toString();
      const voices = synth?.getVoices?.() || [];
      const preferredVoice = preferredURI
        ? (Array.isArray(voices) ? voices.find((v) => String(v?.voiceURI) === String(preferredURI)) : null)
        : null;

      const selectedVoice = preferredVoice || pickSpeechVoice(synth, voiceSettings?.voiceGender, voiceSettings?.voiceLanguage);
      if (selectedVoice) utter.voice = selectedVoice;
      const prefixes = languageToVoicePrefixes(voiceSettings?.voiceLanguage);
      utter.lang = selectedVoice?.lang || prefixes?.[0] || "en";
      // Slightly slower/neutral pitch sounds more natural for many voices
      utter.rate = 0.97;
      utter.pitch = 1.0;
      utter.volume = 1;
      synth.speak(utter);
    } catch (e) {
      // no-op
    }
  };

  const speak = async (text) => {
    // Use AI voice if voiceSource is "ai" (StreamElements Neural voices)
    if (voiceSettings?.voiceSource === "ai") {
      const success = await speakWithAi(text);
      if (success) return;
      // If AI fails, fall through to browser TTS
    }
    // Use browser/system speech synthesis (Windows TTS voices)
    speakWithBrowser(text);
  };

  const matchesVoiceFilters = (order) => {
    const ordType = (order?.ordType || "").toUpperCase();
    const isExternal = order?.isExternalOnlineOrder === true;

    if (isExternal && voiceSettings?.types?.externalApi !== true) return false;

    if (ordType === "DELIVERY") return voiceSettings?.types?.delivery === true;
    if (ordType === "DINEIN") return voiceSettings?.types?.dinein === true;
    // In this app TAKEAWAY is effectively pickup
    if (ordType === "TAKEAWAY") return voiceSettings?.types?.pickup === true;

    // unknown ordType -> allow
    return true;
  };

  const buildAnnouncementText = (order) => {
    const staff = (voiceSettings?.staffName || "Chef").trim() || "Chef";
    const ordType = (order?.ordType || "order").toLowerCase();
    const token = order?.name || order?.transNo || "";
    const isExternal = order?.isExternalOnlineOrder === true;
    const deliveryName = (order?.aggregatorName || order?.aggregatorId || "").toString().trim();

    // Special localized text for Malayalam to sound more natural
    if (voiceSettings?.voiceLanguage === "ml") {
      const aggPart = isExternal
        ? (deliveryName ? `${deliveryName} delivery` : "delivery")
        : ordType || "order";

      const base = `${staff},HI... pootheeya ${aggPart} ninnum order undu`;
      return token ? `${base}, token ${token}.` : `${base}.`;
    }

    // Special localized text for Arabic
    if (voiceSettings?.voiceLanguage === "ar") {
      // Example: "شيف، طلب جديد من طلبات، توصيل، رقم 15"
      // Transliteration: "Chef, talab jadeed min Talabat, tawseel, raqam 15"
      const aggPart = isExternal
        ? (deliveryName ? `min ${deliveryName}` : "")
        : "";
      const orderType = ordType === "delivery" ? "tawseel" : (ordType === "dinein" ? "daakhil" : ordType);

      const base = `${staff}, talab jadeed ${aggPart}, ${orderType}`;
      return token ? `${base}, raqam ${token}.` : `${base}.`;
    }

    // Default English-style announcement
    const externalPrefix = isExternal ? (deliveryName ? deliveryName : "online") : "";
    const parts = [staff, "new", externalPrefix, ordType, "K O T"]
      .filter(Boolean)
      .join(" ");

    // Add short pauses using commas to reduce robotic feel
    return token ? `${parts}, token ${token}.` : `${parts}.`;
  };

  useEffect(() => {
    setVoiceSettings(loadVoiceSettings());
    const handler = () => setVoiceSettings(loadVoiceSettings());
    window.addEventListener("kotVoiceSettingsChanged", handler);
    return () => window.removeEventListener("kotVoiceSettingsChanged", handler);
  }, []);

  useEffect(() => {
    // When device filter changes, mark currently visible list as seen to avoid false "new" announcements
    if (!Array.isArray(filteredKotOrderList)) return;
    filteredKotOrderList.forEach((o) => o?._id && seenKotIdsRef.current.add(String(o._id)));
  }, [voiceSettings?.deviceIds]);

  useEffect(() => {
    const handler = (evt) => {
      const detail = evt?.detail;
      if (!detail) return;

      const previewType = detail?.previewType;
      const previewSettings = { ...getDefaultVoiceSettings(), ...detail, types: { ...getDefaultVoiceSettings().types, ...(detail?.types || {}) } };

      // Temporarily apply preview settings for voice selection and announcement text
      const prev = voiceSettings;
      setVoiceSettings(previewSettings);

      const run = async () => {
        try {
          if (previewType === "sound" && previewSettings?.soundEnabled === true) {
            await playNotificationSound(previewSettings?.soundType || "notification");
            return;
          }

          if (previewType === "voice" && previewSettings?.enabled === true) {
            speak(buildAnnouncementText({
              ordType: "DELIVERY",
              name: "5",
              isExternalOnlineOrder: true,
              aggregatorName: "RAK ECOM3",
            }));
          }
        } finally {
          setVoiceSettings(prev);
        }
      };

      run();
    };

    window.addEventListener("kotVoicePreview", handler);
    return () => window.removeEventListener("kotVoicePreview", handler);
  }, [voiceSettings]);

  useEffect(() => {
    if (!Array.isArray(filteredKotOrderList)) return;

    // First hydration: mark existing as seen to avoid speaking for already-loaded list
    if (!hydratedSeenRef.current) {
      filteredKotOrderList.forEach((o) => o?._id && seenKotIdsRef.current.add(String(o._id)));
      hydratedSeenRef.current = true;
      return;
    }

    if (voiceSettings?.enabled !== true && voiceSettings?.soundEnabled !== true) {
      filteredKotOrderList.forEach((o) => o?._id && seenKotIdsRef.current.add(String(o._id)));
      return;
    }

    const newOnes = filteredKotOrderList.filter((o) => {
      const id = o?._id ? String(o._id) : null;
      if (!id) return false;
      return !seenKotIdsRef.current.has(id);
    });

    newOnes.forEach((o) => o?._id && seenKotIdsRef.current.add(String(o._id)));

    const firstToAnnounce = newOnes.find((o) => matchesVoiceFilters(o));
    if (!firstToAnnounce) return;

    const seq = ++announceSeqRef.current;
    (async () => {
      // sound first, then voice
      if (voiceSettings?.soundEnabled === true) {
        await playNotificationSound(voiceSettings?.soundType || "notification");
      }
      // if a newer announcement started, skip speaking
      if (seq !== announceSeqRef.current) return;
      if (voiceSettings?.enabled === true) {
        speak(buildAnnouncementText(firstToAnnounce));
      }
    })();
  }, [filteredKotOrderList, voiceSettings?.enabled, voiceSettings?.soundEnabled, voiceSettings?.soundType, voiceSettings?.voiceGender, voiceSettings?.voiceLanguage, voiceSettings?.staffName, voiceSettings?.types?.externalApi, voiceSettings?.types?.delivery, voiceSettings?.types?.dinein, voiceSettings?.types?.pickup, voiceSettings?.deviceIds]);

  //initial actions
  useEffect(() => {
    dispatch(switch_to_billing_screen({ billingBoolean: true }));
    dispatch(setHideHeader(true));
    dispatch(setSelectedKOTOrder(null));
    const ids = Array.isArray(voiceSettings?.deviceIds) ? voiceSettings.deviceIds : [];
    const body = {
      branchId: branchPk,
      deviceIds: ids.length > 0 ? ids : undefined,
    };

    if (branchPk) {
      listKotOrderAPI({ body });
    }
  }, [branchPk, voiceSettings?.deviceIds]);

  useEffect(() => {
    dispatch(setSortProduct(null));

    if (branchPk && kotOrderStatus?.status?.key) {
      const ids = Array.isArray(voiceSettings?.deviceIds) ? voiceSettings.deviceIds : [];
      kotSideMenuListApi({
        body: {
          branchId: branchPk,
          status: kotOrderStatus?.status?.key,
          deviceIds: ids.length > 0 ? ids : undefined,
        },
      });
    }
  }, [kotOrderStatus, branchPk, voiceSettings?.deviceIds]);

  useEffect(() => {
    if (branchPk && kotOrderStatus?.status?.key) {
      const ids = Array.isArray(voiceSettings?.deviceIds) ? voiceSettings.deviceIds : [];
      kotSideMenuListApi({
        body: {
          branchId: branchPk,
          status: kotOrderStatus?.status?.key,
          deviceIds: ids.length > 0 ? ids : undefined,
        },
      });
    }
  }, [kotOrderStatus, branchPk, kotOrderList, voiceSettings?.deviceIds]);

  useEffect(() => {
    if (sortProduct) {
      viewKOTSortProductListAPI({
        body: { ...sortProduct, branchId: branchPk },
      });
    }
  }, [sortProduct]);

  useEffect(() => {
    setSendBody((prevSendBody) => ({
      ...prevSendBody,
      status: kotOrderStatus?.status?.key,
    }));
  }, [kotOrderStatus?.status?.key]);

  // Update sendBody when deviceIds change in voiceSettings
  useEffect(() => {
    const ids = Array.isArray(voiceSettings?.deviceIds) ? voiceSettings.deviceIds : [];
    setSendBody((prevSendBody) => ({
      ...prevSendBody,
      deviceIds: ids,
    }));
  }, [voiceSettings?.deviceIds]);

  // socket connection with hybrid support (online + offline)
  useEffect(() => {
    //connect socket io to backend
    const socket = io(axios.defaults.baseURL, {
      path: "/socket.io/",
      reconnection: true,
      transports: ["websocket"],
      reconnectionAttempts: 5,
      reconnectionDelay: 1000,
      reconnectionDelayMax: 5000,
    });

    //get backend response if connect the socket
    socket.on("connect", () => {
      console.log('🔌 KOT: Real Socket.IO connected');
      hybridSocket.setBackendStatus(true);
      hybridSocket.setRealSocket(socket);
      
      if (data && branchPk) {
        socket.emit("setUsername", data?._id, branchPk);
        dispatch(setNetworkStatus(NETWORK.ONLINE));
      }
    });

    socket.on("disconnect", () => {
      console.log('🔌 KOT: Real Socket.IO disconnected');
      hybridSocket.setBackendStatus(false);
      dispatch(setNetworkStatus(NETWORK.OFFLINE));
    });

    socket.on("connect_error", () => {
      console.log('❌ KOT: Socket.IO connection error - switching to offline mode');
      hybridSocket.setBackendStatus(false);
      dispatch(setNetworkStatus(NETWORK.OFFLINE));
    });

    // Register hybrid socket listeners (work both online and offline)
    const handleNewKotOrder = () => {
      console.log('📥 KOT: New order received');
      listKotOrderAPI({ body: sendBody });
    };
    const handleToCook = () => {
      console.log('📥 KOT: To cook status received');
      listKotOrderAPI({ body: sendBody });
    };
    const handleCompleted = () => {
      console.log('📥 KOT: Completed status received');
      listKotOrderAPI({ body: sendBody });
    };
    const handleReset = () => {
      console.log('📥 KOT: Reset status received');
      listKotOrderAPI({ body: sendBody });
    };
    const handleDelivery = () => {
      console.log('📥 KOT: Delivery status received');
      listKotOrderAPI({ body: sendBody });
    };

    hybridSocket.on("newKotOrder", handleNewKotOrder);
    hybridSocket.on("toKotCookStatus", handleToCook);
    hybridSocket.on("toKotCompleteStatus", handleCompleted);
    hybridSocket.on("toKotResetStatus", handleReset);
    hybridSocket.on("toKotDeliveryStatus", handleDelivery);

    // Clean up function
    return () => {
      hybridSocket.off("newKotOrder", handleNewKotOrder);
      hybridSocket.off("toKotCookStatus", handleToCook);
      hybridSocket.off("toKotCompleteStatus", handleCompleted);
      hybridSocket.off("toKotResetStatus", handleReset);
      hybridSocket.off("toKotDeliveryStatus", handleDelivery);
      
      if (socket) {
        socket.off("connect");
        socket.off("disconnect");
        socket.off("connect_error");
        socket.disconnect();
      }
    };
  }, [sendBody]);

  // Check for online status and show alert message
  useEffect(() => {
    dispatch(
      setKotOrderStatus({
        index: 0,
        status: { key: "ALL", name: "All", color: "#cc009c" },
      })
    );
    const handleOnlineStatus = () => {
      if (navigator.onLine) {
        dispatch(setNetworkStatus(NETWORK.ONLINE));

        dispatch(
          setAlertMessage({ status: "success", message: "You are online!" })
        );
      } else {
        dispatch(setNetworkStatus(NETWORK.OFFLINE));
        dispatch(
          setAlertMessage({ status: "error", message: "You are offline!" })
        );
      }
    };

    window.addEventListener("online", handleOnlineStatus);
    window.addEventListener("offline", handleOnlineStatus);

    return () => {
      window.removeEventListener("online", handleOnlineStatus);
      window.removeEventListener("offline", handleOnlineStatus);
    };
  }, []);

  useEffect(() => {
    // To remove header when exiting the page
    return () => {
      dispatch(switch_to_billing_screen({ billingBoolean: false }));
      dispatch(setHideHeader(false));
    };
  }, [location]);
  useEffect(() => {
    if (networkStatus === NETWORK.ONLINE) {
      listKotOrderAPI({ body: sendBody });
    }
  }, [networkStatus]);

  //setAlertMessage
  const setAlertMessageHandler = () => {
    if (alertMessage !== null) {
      dispatch(setAlertMessage(null));
    }
  };

  return (
    <div id="kot-container" data-theme={darkMode ? "dark" : "light"}>
      <div className="kot-container">
        <KotHeader branchId={branchPk} />
        <div className="kot-body">
          <KotSideMenu />
          <KotBody kotOrders={filteredKotOrderList} />
          <KotPopup />
        </div>
      </div>
      <LoadingForm loading={isLoading} />
      <AlertMessage
        status={alertMessage?.status}
        alertMessage={alertMessage?.message}
        setApiAlertMessage={setAlertMessageHandler}
      />
    </div>
  );
};

export default KitchenOrderTicket;
